import cx from "classnames";
import React from "react";
import { Paragraph } from "@trainline/depot-web";
import * as styles from "./Alert.module.css";
const Alert = ({
  testId = "alert",
  variant = "negative",
  type = "compact",
  children,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", {
  className: cx(styles.root, styles.fullWidth, {
    [styles.negative]: variant === "negative",
    [styles.warning]: variant === "warning",
    [styles.positive]: variant === "positive",
    [styles.info]: variant === "info",
    [styles.compact]: type === "compact"
  }, className),
  "data-testid": testId,
  role: "alert",
  ...rest
}, /* @__PURE__ */ React.createElement(Paragraph, {
  as: "span"
}, children));
var Alert_default = Alert;
export {
  Alert,
  Alert_default as default
};
